import React, { useEffect, useState } from 'react'
import CustomToast from '../Toaster/CustomToast';
import { Flex, FormControl, Input, useToast } from '@chakra-ui/react';
import { PulseLoader } from 'react-spinners';
import authenticationService from '../../api/authenticationService';
import PasswordInput from '../PasswordInput';

const RegisterCompany = (props) => {
	const { loginAuthForm, loginToggle } = props;
	const [passwordMismatch, setPasswordMismatch] = useState(false);
	const [registerOrgName, setResigterOrgName] = useState("");
	const [registerOrgEmail, setRegisterOrgEmail] = useState("");
	const [orgAdminName, setOrgAdminName] = useState("");
	const [registerOrgPassword, setRegisterOrgPassword] = useState("")
	const [confirmRegisterOrgPassword, setConfirmRegisterOrgPassword] = useState("");
	const [registerOrgPhone, setRegisterOrgPhone] = useState("")
	const [isLoading, setIsloading] = useState(false);
	const [isEmailExist, setIsEmailExist] = useState("");
	const [isMobileExist, setIsMobileExist] = useState("");
	const [isCompanyExist, setIsCompanyExist] = useState("");
	const toast = useToast();

	useEffect(() => {
		if (loginToggle) {
			setOrgAdminName("")
			setResigterOrgName("");
			setRegisterOrgEmail("");
			setRegisterOrgPassword("");
			setConfirmRegisterOrgPassword("");
			setRegisterOrgPhone("");
		}
	}, [loginToggle])

	const handleResgisterCompany = async (event) => {
		event.preventDefault();

						setIsCompanyExist("")
						setIsMobileExist("")
						setIsEmailExist("")
		if (registerOrgPassword !== confirmRegisterOrgPassword) {
			setPasswordMismatch(true);
			return (
				toast({
					render: ({ onClose }) => (
						<CustomToast title={`Password and Confirm Password do not match.`} status="warning" onClose={onClose} />
					), position: "top", duration: 3000, isClosable: true,
				})
			)
		}
		setPasswordMismatch(false);

		const payload = {
			comp_name: registerOrgName,
			comp_owner_name: orgAdminName,
			comp_mobile: registerOrgPhone,
			comp_email: registerOrgEmail.toLowerCase(),
			comp_password: registerOrgPassword,
		};
		setIsloading(true);
		try{
			const res = await authenticationService.company_register(payload)
			console.log(res,'============Response===========');

			if(res.data?.message) {
				loginAuthForm();
				return (
					toast({
						render: ({ onClose }) => (
							<CustomToast title={`You've completed the registration. Check your email to verify your account.`} status="success" onClose={onClose} />
						), position: "top", duration: 5000, isClosable: true,
					})
				)
			}else{
				if(res.data?.comp_name?.status === 0) {
					setIsCompanyExist(res.data?.comp_name?.message)
				}else{
					setIsCompanyExist("")
				}

				if(res.data?.comp_mobile?.status === 0){
					setIsMobileExist(res.data?.comp_mobile?.message)
				}else{
					setIsMobileExist("")
				}

				if(res.data?.comp_email?.status === 0){
					setIsEmailExist(res.data?.comp_email?.message)
				}else{
					setIsEmailExist("")
				}
			}
		}catch(error){
			console.error("Login failed:", error);
		}finally{
			setIsloading(false);
		}
	};

	return (
		<div>
			<form onSubmit={handleResgisterCompany} className="signup-page">
				<Flex flexDir={"column"} gap={4} justifyContent={"center"} className="signupFields" color={"#FFF"}>
					<FormControl id="Organization name" isRequired >
						<Input
							size={"sm"}
							type="text"
							value={registerOrgName}
							placeholder="Organization Name"
							onChange={(e) => setResigterOrgName(e.target.value)}
							className="custom-input"
						/>
						{isCompanyExist.length > 0 && <span className='registration_warning'>{isCompanyExist}</span>}
					</FormControl>
					<FormControl id="Name" isRequired>
						<Input
							size={"sm"}
							type="text"
							placeholder="Name"
							value={orgAdminName}
							onChange={(e) => setOrgAdminName(e.target.value)}
						/>
					</FormControl>
					<FormControl id="org_phone" isRequired>
						<Input
							size={"sm"}
							type="number"
							placeholder="Phone"
							value={registerOrgPhone}
							onChange={(e) => setRegisterOrgPhone(e.target.value)}
						/>
						{isMobileExist.length > 0 && <span className='registration_warning'>{isMobileExist}</span>}
					</FormControl>
					<FormControl id="email" isRequired>
						<Input
							size={"sm"}
							type="email"
							placeholder="Email"
							value={registerOrgEmail}
							onChange={(e) => setRegisterOrgEmail(e.target.value)}
							className="custom-input"
						/>
						{isEmailExist.length > 0 && <span className='registration_warning'>{isEmailExist}</span>}
					</FormControl>
					<FormControl id="password" isRequired>
						<PasswordInput
							size={"sm"}
							placeholder="Password"
							value={registerOrgPassword}
							onChange={(e) => setRegisterOrgPassword(e.target.value)}
						/>
					</FormControl>
					<FormControl id="confirmPassword" isRequired>
						<PasswordInput
							size={"sm"}
							placeholder="Confirm password"
							value={confirmRegisterOrgPassword}
							onChange={(e) => setConfirmRegisterOrgPassword(e.target.value)}
						/>
					</FormControl>

					<button type="submit" className="login-btn btn-pink" >{isLoading ? <PulseLoader color="#FFFFFF" /> : "Sign Up"}</button>
					<button type='button' className="login-btn btn-white mb-3" disabled={isLoading} onClick={loginAuthForm}>Sign In</button>
				</Flex>
			</form>
		</div>
	)
}

export default RegisterCompany